import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from 'react-i18next';
import './modern-styles.css';
import './toast-styles.css';
import { getStoredUser } from '../../utils/safeStorage';

import { SidebarContext } from "../../AppRoutes";
import { updateRaioEntregaEmpresa, updateRaioStepEmpresa, getEmpresa, deleteRaioEntrega, deleteBairroEntrega, getBairros, updateTypeRegion, updateBairroEntregaEmpresa } from "../../services/api";
import PermissionGate from "../../services/PermissionGate";


import { useFormik } from "formik";
import * as Yup from "yup";

import { HiLocationMarker } from 'react-icons/hi';
import { MdAdd, MdRemove } from "react-icons/md";
import { BsTrash, BsMap } from "react-icons/bs";
import { toast } from "react-toastify";
import Map from './index';
import InputMoney from "./InputMoney";
import ConfirmDialog from "../../components/ConfirmDialog";
import { formatPriceWithSymbol } from "../../utils/currency";

const AddRaioEntrega = ({ embedded = false }) => {
    const { t, i18n } = useTranslation(['storeInfo', 'common']);
    const userParse = getStoredUser();
    const userID = userParse?._id;


    const empresa = localStorage.getItem('empresa');
    const empresaParse = JSON.parse(empresa);
    const idEmpresa = empresaParse.id_empresa;
    const objIdEmpresa = empresaParse._id;

    const { sidebar } = useContext(SidebarContext);
    const [isFocused, setIsFocused] = useState(false);

    const [latitudeEmpresa, setLatitudeEmpresa] = useState(null);
    const [longitudeEmpresa, setLongitudeEmpresa] = useState(null);
    const [raio, setRaio] = useState(1);
    const [valorEntrega, setValorEntrega] = useState(0);
    // Incremento do raio em METROS (250|500|1000). Vem de empresa.raio_entrega_step;
    // default 1000 = faixas de km inteiro (comportamento legado, BR).
    const [stepMetros, setStepMetros] = useState(1000);
    const [savingStep, setSavingStep] = useState(false);
    const stepKm = stepMetros / 1000;
    // Arredonda a 3 casas (evita drift de float ao somar 0.25 repetidamente)
    const round3 = (v) => Math.round(v * 1000) / 1000;
    // Exibição: "250 m" abaixo de 1km; "1,25 km" (pt) / "1.25 km" (en) acima; "0" puro
    const formatRadius = (meters) => {
        if (meters === 0) return '0';
        if (meters < 1000) return `${Math.round(meters)} m`;
        return `${(meters / 1000).toLocaleString(i18n.language, { maximumFractionDigits: 2 })} km`;
    };
    const [arrayRaioEntrega, setArrayRaioEntrega] = useState([]);
    const [arrayBairroEntrega, setArrayBairroEntrega] = useState([]);
    const [typeOfRegion, setTypeOfRegion] = useState("");
    const [loadingMap, setLoadingMap] = useState(true);

    // Estados para loading de submit
    const [savingRaio, setSavingRaio] = useState(false);
    const [savingBairro, setSavingBairro] = useState(false);

    // Estados para modal de confirmação
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [regionTypeChange, setRegionTypeChange] = useState(null);

    // Formik para validação
    const formik = useFormik({
        initialValues: {
            vinculo_bairro: '',
        },
        validationSchema: Yup.object({
            vinculo_bairro: Yup.string().required(t('common:neighborhoodRequired')),
        }),
        onSubmit: (values) => {
            adicionaBairro(values.vinculo_bairro);
        },
    });

    // Carrega dados da empresa
    useEffect(() => {
        const carregaEmpresa = async () => {
            try {
                setLoadingMap(true);
                const response = await getEmpresa(userID, idEmpresa);
                if (response.status === 200) {
                    const empresaData = response.data.empresa;
                    process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Dados da empresa carregados:', empresaData);

                    // Verificar se tem coordenadas válidas
                    if (empresaData.latitude && empresaData.longitude &&
                        empresaData.latitude !== '0' && empresaData.longitude !== '0' &&
                        parseFloat(empresaData.latitude) !== 0 && parseFloat(empresaData.longitude) !== 0) {

                        setLatitudeEmpresa(parseFloat(empresaData.latitude));
                        setLongitudeEmpresa(parseFloat(empresaData.longitude));
                        process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Coordenadas válidas carregadas:', {
                            lat: parseFloat(empresaData.latitude),
                            lng: parseFloat(empresaData.longitude)
                        });
                    } else {
                        process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Coordenadas inválidas ou não definidas');
                    }

                    const raios = empresaData.raios_entrega || [];
                    setArrayRaioEntrega(raios);
                    setArrayBairroEntrega(empresaData.bairros_entrega || []);

                    // Incremento configurado da loja (metros). Usar a variável local no
                    // init abaixo — o state stepMetros só atualiza no próximo render.
                    const stepCarregado = empresaData.raio_entrega_step || 1000;
                    setStepMetros(stepCarregado);

                    // Auto-set próxima faixa (último teto + 1 incremento)
                    const sorted = [...raios].sort((a, b) => a.raio_entrega - b.raio_entrega);
                    const lastKm = sorted.length > 0 ? sorted[sorted.length - 1].raio_entrega / 1000 : 0;
                    setRaio(Math.round((lastKm + stepCarregado / 1000) * 1000) / 1000);
                    setTypeOfRegion(empresaData.type_of_region || "raio");
                }
            } catch (error) {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.error("Erro ao carregar empresa:", error);
            } finally {
                setLoadingMap(false);
            }
        };
        carregaEmpresa();
    }, [userID, idEmpresa]);

    const adicionaRaioNoMapa = async () => {
        if (savingRaio) return;

        if (!raio || raio <= nextRangeStart) {
            return toast.error(t('toasts.radiusRequired'));
        }

        if (valorEntrega === '' || valorEntrega === null || valorEntrega === undefined) {
            return toast.error(t('toasts.feeRequired'));
        }

        // Permitir valor 0 (entrega grátis)
        if (valorEntrega < 0) {
            return toast.error(t('toasts.feeNegative'));
        }

        // km → metros, com snap ao incremento da loja (mantém as faixas alinhadas
        // ao step: 0.3 digitado com step 250 vira 250; 0.4 vira 500).
        let raioToApi = Math.round((raio * 1000) / stepMetros) * stepMetros;
        if (raioToApi <= nextRangeStart * 1000) {
            // Snap caiu no teto anterior (ou abaixo) → empurra para o próximo múltiplo válido
            raioToApi = Math.round(nextRangeStart * 1000) + stepMetros;
        }
        let valorToApi = parseFloat(valorEntrega.toString().replace(',', '.'));

        // Verificar se a conversão gerou NaN
        if (isNaN(valorToApi)) {
            return toast.error(t('toasts.feeInvalid'));
        }

        // Garantir que é um número válido
        valorToApi = Number(valorToApi);

        setSavingRaio(true);
        try {
            const response = await updateRaioEntregaEmpresa(objIdEmpresa, idEmpresa, userID, raioToApi, valorToApi);
            if (response.status === 200) {
                toast.success(response.data.msg);

                // Recarregar dados da empresa
                const empresaResponse = await getEmpresa(userID, idEmpresa);
                const newRaios = empresaResponse.data.empresa.raios_entrega || [];
                setArrayRaioEntrega(newRaios);

                // Auto-set próxima faixa (último teto + 1 incremento)
                const sorted = [...newRaios].sort((a, b) => a.raio_entrega - b.raio_entrega);
                const lastKm = sorted.length > 0 ? sorted[sorted.length - 1].raio_entrega / 1000 : 0;
                setRaio(round3(lastKm + stepKm));
                setValorEntrega(0);
            } else if (response.status === 201) {
                toast.warn(response.data.msg);
            }
        } catch (error) {
            toast.error(t('toasts.radiusAddError'));
        } finally {
            setSavingRaio(false);
        }
    };

    const adicionaBairro = async (bairro) => {
        // Permitir valor 0 (entrega gratis)
        if (valorEntrega === '' || valorEntrega === null || valorEntrega === undefined) {
            return toast.error(t('toasts.feeRequired'));
        }

        if (valorEntrega < 0) {
            return toast.error(t('toasts.feeNegative'));
        }

        const valorToApi = parseFloat(valorEntrega.toString().replace(',', '.'));

        setSavingBairro(true);
        try {
            const response = await updateBairroEntregaEmpresa(objIdEmpresa, idEmpresa, userID, bairro, valorToApi);
            if (response.status === 200) {
                toast.success(response.data.msg);

                // Recarregar dados da empresa
                const empresaResponse = await getEmpresa(userID, idEmpresa);
                setArrayBairroEntrega(empresaResponse.data.empresa.bairros_entrega || []);

                setValorEntrega(0);
                formik.resetForm();
            } else if (response.status === 201) {
                toast.warn(response.data.msg);
            }
        } catch (error) {
            toast.error(t('toasts.neighborhoodAddError'));
        } finally {
            setSavingBairro(false);
        }
    };

    const deletaRaioEntrega = async (raio_entrega_id) => {
        try {
            const response = await deleteRaioEntrega(userID, idEmpresa, raio_entrega_id);
            if (response.status === 200) {
                toast.success(response.data.msg);

                // Recarregar dados da empresa
                const empresaResponse = await getEmpresa(userID, idEmpresa);
                const newRaios = empresaResponse.data.empresa.raios_entrega || [];
                setArrayRaioEntrega(newRaios);

                // Auto-set próxima faixa (último teto + 1 incremento)
                const sorted = [...newRaios].sort((a, b) => a.raio_entrega - b.raio_entrega);
                const lastKm = sorted.length > 0 ? sorted[sorted.length - 1].raio_entrega / 1000 : 0;
                setRaio(round3(lastKm + stepKm));
            } else {
                toast.error(response.data.msg);
            }
        } catch (error) {
            toast.error(t('toasts.radiusDeleteError'));
        }
    };

    const deletaBairroEntrega = async (bairro_entrega_id) => {
        try {
            const response = await deleteBairroEntrega(userID, idEmpresa, bairro_entrega_id);
            if (response.status === 200) {
                toast.success(response.data.msg);

                // Recarregar dados da empresa
                const empresaResponse = await getEmpresa(userID, idEmpresa);
                setArrayBairroEntrega(empresaResponse.data.empresa.bairros_entrega || []);
            } else {
                toast.error(response.data.msg);
            }
        } catch (error) {
            toast.error(t('toasts.neighborhoodDeleteError'));
        }
    };

    const orderedArrayRaioEntrega = arrayRaioEntrega.sort((a, b) => a.raio_entrega - b.raio_entrega);
    const orderedArrayBairroEntrega = arrayBairroEntrega.sort((a, b) => a.bairro_entrega.localeCompare(b.bairro_entrega));

    // Calcula o início da próxima faixa (baseado no último raio cadastrado)
    const nextRangeStart = orderedArrayRaioEntrega.length > 0
        ? orderedArrayRaioEntrega[orderedArrayRaioEntrega.length - 1].raio_entrega / 1000
        : 0;

    const handleEditRegionType = (newType) => {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log('handleEditRegionType chamado:', { newType, currentType: typeOfRegion });

        if (newType === typeOfRegion) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Mesmo tipo selecionado, nada a fazer');
            return;
        }

        // Verificar se há dados que serão perdidos
        const hasDataToDelete = (typeOfRegion === 'raio' && arrayRaioEntrega.length > 0) ||
                               (typeOfRegion === 'bairro' && arrayBairroEntrega.length > 0);

        if (hasDataToDelete) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Há dados que serão perdidos, mostrando modal de confirmação');
            setRegionTypeChange(newType);
            setConfirmOpen(true);
        } else {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Sem dados para perder, alterando diretamente');
            changeRegionType(newType);
        }
    };

    const changeRegionType = async (newType = regionTypeChange) => {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log('changeRegionType chamado:', { newType, currentType: typeOfRegion });

        try {
            // Primeiro, limpar os dados do tipo atual no backend se houver mudança
            if (typeOfRegion && typeOfRegion !== newType) {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Limpando dados do tipo anterior:', typeOfRegion);

                if (typeOfRegion === 'raio' && arrayRaioEntrega.length > 0) {
                    process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Removendo raios existentes...');
                    for (const raio of arrayRaioEntrega) {
                        try {
                            await deleteRaioEntrega(userID, idEmpresa, raio._id);
                            process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Raio removido:', raio._id);
                        } catch (error) {
                            process.env.REACT_APP_ISDEVELOP === 'true' && console.warn('Erro ao remover raio:', raio._id, error);
                        }
                    }
                    setArrayRaioEntrega([]);
                } else if (typeOfRegion === 'bairro' && arrayBairroEntrega.length > 0) {
                    process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Removendo bairros existentes...');
                    for (const bairro of arrayBairroEntrega) {
                        try {
                            await deleteBairroEntrega(userID, idEmpresa, bairro._id);
                            process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Bairro removido:', bairro._id);
                        } catch (error) {
                            process.env.REACT_APP_ISDEVELOP === 'true' && console.warn('Erro ao remover bairro:', bairro._id, error);
                        }
                    }
                    setArrayBairroEntrega([]);
                }
            }

            // Agora atualizar o tipo de região
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Atualizando tipo de região para:', newType);
            const response = await updateTypeRegion(objIdEmpresa, idEmpresa, userID, newType);
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Resposta updateTypeRegion:', response);

            if (response.status === 200) {
                setTypeOfRegion(newType);

                // Garantir que os arrays estão limpos
                setArrayRaioEntrega([]);
                setArrayBairroEntrega([]);

                // Resetar valores
                setValorEntrega(0);
                setRaio(1);
                formik.resetForm();

                // Recarregar dados da empresa para garantir sincronização
                process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Recarregando dados da empresa...');
                const empresaResponse = await getEmpresa(userID, idEmpresa);
                const empresa = empresaResponse.data.empresa;

                // Carregar arrays baseado no novo tipo
                if (newType === 'raio' && empresa.raios_entrega) {
                    setArrayRaioEntrega(empresa.raios_entrega);
                    process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Raios carregados:', empresa.raios_entrega.length);
                } else if (newType === 'bairro' && empresa.bairros_entrega) {
                    setArrayBairroEntrega(empresa.bairros_entrega);
                    process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Bairros carregados:', empresa.bairros_entrega.length);
                }

                toast.success(t('toasts.regionTypeChanged', { type: newType === 'raio' ? t('deliveryMap.regionType.radius') : t('deliveryMap.regionType.neighborhood') }));
                process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`Tipo de região alterado para: ${newType}`);

                // Fechar modal
                setConfirmOpen(false);
                setRegionTypeChange(null);
            } else {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.error('Erro na resposta da API:', response);
                toast.error(t('toasts.regionTypeError'));
            }
        } catch (error) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.error('Erro ao alterar tipo de região:', error);
            toast.error(t('toasts.regionTypeError'));
        }
    };

    const onChange = (event, nameObject, isNumber) => {
        const value = event.target.value;
        if (isNumber) {
            setValorEntrega(value);
        }
    };

    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
    };

    const handleDecrement = (type) => {
        if (type !== "raio") return;
        const next = round3(raio - stepKm);
        // O teto da faixa precisa continuar acima do início (nextRangeStart)
        if (next > nextRangeStart) {
            setRaio(next);
        }
    };

    const handleIncrement = (type) => {
        if (type === "raio" && raio < 9999) {
            setRaio(round3(raio + stepKm));
        }
    };

    // Troca o incremento do raio da loja (250|500|1000 m). Persiste no backend e
    // realinha o teto em edição para o próximo múltiplo do novo incremento.
    const handleChangeStep = async (novoStepMetros) => {
        if (savingStep || novoStepMetros === stepMetros) return;
        const stepAnterior = stepMetros;
        setSavingStep(true);
        setStepMetros(novoStepMetros);
        setRaio(round3(nextRangeStart + novoStepMetros / 1000));
        try {
            await updateRaioStepEmpresa(novoStepMetros);
            toast.success(t('deliveryMap.radiusMode.stepSaved', 'Incremento do raio atualizado!'));
        } catch (error) {
            // Reverter em caso de falha (não deixar UI e banco divergirem)
            setStepMetros(stepAnterior);
            setRaio(round3(nextRangeStart + stepAnterior / 1000));
            toast.error(t('deliveryMap.radiusMode.stepError', 'Erro ao atualizar o incremento do raio.'));
        } finally {
            setSavingStep(false);
        }
    };

    // Estilos condicionais baseados no modo embedded
    const containerStyle = embedded ? {
        width: '100%',
        minHeight: 'auto',
        padding: '0',
        background: 'transparent',
    } : {
        marginLeft: sidebar ? '250px' : '100px',
        width: sidebar ? 'calc(100% - 250px)' : 'calc(100% - 100px)',
        minHeight: '100vh',
        padding: '28px 24px',
    };

    // Conteudo principal
    const mainContent = (
        <>
        <div className="modern-delivery-container" style={containerStyle}>
                {!embedded && (
                    <div className="modern-delivery-header">
                        <h1>{t('deliveryMap.title')}</h1>
                        <p className="subtitle">{t('deliveryMap.subtitle', 'Configure as áreas e taxas de entrega do seu estabelecimento')}</p>
                    </div>
                )}

                <div className="modern-delivery-content">
                    {/* Toggle Tabs */}
                    <div className="modern-toggle-container">
                        <div className="modern-toggle-buttons">
                            <button
                                className={`modern-toggle-btn ${typeOfRegion === "bairro" ? "active" : ""}`}
                                onClick={() => handleEditRegionType("bairro")}
                                type="button"
                            >
                                <HiLocationMarker size={15} />
                                {t('deliveryMap.regionType.neighborhood')}
                            </button>
                            <button
                                className={`modern-toggle-btn ${typeOfRegion === "raio" ? "active" : ""}`}
                                onClick={() => handleEditRegionType("raio")}
                                type="button"
                            >
                                <BsMap size={14} />
                                {t('deliveryMap.regionType.radius')}
                            </button>
                        </div>
                    </div>

                    {/* Tab Content */}
                    <div className="modern-tab-content">
                        {typeOfRegion === "bairro" ? (
                            <>
                                {/* Neighborhood Form */}
                                <div className="modern-form-section">
                                    <form onSubmit={formik.handleSubmit}>
                                        <div className="modern-form-row">
                                            <div className="modern-form-group">
                                                <label>
                                                    {t('deliveryMap.neighborhoodMode.neighborhoodLabel')} <span>*</span>
                                                </label>
                                                <input
                                                    placeholder={t('deliveryMap.neighborhoodMode.neighborhoodPlaceholder')}
                                                    id="vinculo_bairro"
                                                    name="vinculo_bairro"
                                                    type="text"
                                                    onChange={formik.handleChange}
                                                    value={formik.values.vinculo_bairro}
                                                />
                                                {formik.errors.vinculo_bairro && (
                                                    <div style={{ color: '#ef4444', fontSize: '0.78rem', marginTop: '4px' }}>
                                                        {formik.errors.vinculo_bairro}
                                                    </div>
                                                )}
                                            </div>

                                            <div className="modern-form-group">
                                                <label>
                                                    {t('deliveryMap.neighborhoodMode.deliveryFeeLabel')} <span>*</span>
                                                </label>
                                                <div
                                                    className="modern-input-money-container"
                                                    style={{
                                                        border: `1px solid ${isFocused ? 'rgb(49,140,213)' : '#d1d5db'}`,
                                                        borderRadius: '7px',
                                                        transition: 'all 0.2s',
                                                        background: '#fff',
                                                        boxShadow: isFocused ? '0 0 0 3px rgba(49,140,213,0.12)' : '0 1px 2px rgba(0,0,0,0.04)',
                                                        overflow: 'hidden',
                                                        height: '40px',
                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    }}
                                                >
                                                    <InputMoney
                                                        onChange={(event) => onChange(event, 'price', true)}
                                                        value={valorEntrega}
                                                        onFocus={handleFocus}
                                                        onBlur={handleBlur}
                                                        placeholder="0,00"
                                                        addonBefore=""
                                                    />
                                                </div>
                                            </div>

                                            <button
                                                type="submit"
                                                className="modern-add-btn"
                                                disabled={savingBairro || !formik.values.vinculo_bairro || valorEntrega === '' || valorEntrega === null || valorEntrega === undefined}
                                            >
                                                <MdAdd size={18} />
                                                {savingBairro ? t('common:saving', 'Salvando...') : t('deliveryMap.neighborhoodMode.addButton')}
                                            </button>
                                        </div>
                                    </form>
                                </div>

                                {/* Neighborhood List */}
                                <div className="modern-records-section">
                                    <div className="modern-records-header">
                                        <h3 className="modern-records-title">{t('deliveryMap.neighborhoodMode.registeredTitle', 'Bairros Cadastrados')}</h3>
                                        <span className="modern-records-count">
                                            {arrayBairroEntrega.length} {t('deliveryMap.records', 'registros')}
                                        </span>
                                    </div>

                                    <div className="delivery-data-table">
                                        <div className="delivery-data-thead">
                                            <div className="delivery-data-tr">
                                                <div className="delivery-data-th">{t('deliveryMap.neighborhoodMode.tableHeaders.neighborhood')}</div>
                                                <div className="delivery-data-th col-taxa">{t('deliveryMap.neighborhoodMode.tableHeaders.fee')}</div>
                                                <div className="delivery-data-th col-acoes">{t('deliveryMap.neighborhoodMode.tableHeaders.actions')}</div>
                                            </div>
                                        </div>

                                        <div className="delivery-data-tbody">
                                            {orderedArrayBairroEntrega.length > 0 ? (
                                                orderedArrayBairroEntrega.map((item, index) => (
                                                    <div key={index} className="delivery-data-row">
                                                        <div className="delivery-data-td">{item.bairro_entrega}</div>
                                                        <div className="delivery-data-td col-taxa">
                                                            {formatPriceWithSymbol(item.valor_entrega)}
                                                        </div>
                                                        <div className="delivery-data-td col-acoes">
                                                            <button
                                                                className="modern-delete-btn"
                                                                onClick={() => deletaBairroEntrega(item._id)}
                                                                title={t('deliveryMap.deleteButton')}
                                                            >
                                                                <BsTrash size={14} />
                                                            </button>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="modern-empty-state">
                                                    <div className="icon">
                                                        <HiLocationMarker />
                                                    </div>
                                                    <h3>{t('deliveryMap.neighborhoodMode.emptyState')}</h3>
                                                    <p>{t('deliveryMap.neighborhoodMode.emptyStateDescription', 'Adicione bairros para definir as taxas de entrega por região')}</p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <>
                                {/* Map */}
                                <div className="modern-map-section" style={{ minHeight: '400px' }}>
                                    {loadingMap ? (
                                        <div className="modern-map-loading">
                                            <BsMap size={40} style={{ opacity: 0.35, marginBottom: '12px' }} />
                                            <p>{t('loading')}</p>
                                        </div>
                                    ) : latitudeEmpresa && longitudeEmpresa ? (
                                        <Map
                                            arrayRaioEntrega={arrayRaioEntrega}
                                            latitudeEmpresa={latitudeEmpresa}
                                            longitudeEmpresa={longitudeEmpresa}
                                        />
                                    ) : (
                                        <div className="modern-map-loading">
                                            <BsMap size={40} style={{ opacity: 0.35, marginBottom: '12px' }} />
                                            <h3>{t('deliveryMap.locationNotDefined', 'Localização não definida')}</h3>
                                            <p>{t('deliveryMap.locationRequired', 'Para visualizar o mapa, você precisa definir a localização do seu estabelecimento.')}</p>
                                            <p style={{ marginTop: '4px' }}>{t('deliveryMap.accessSettings', 'Acesse:')} <strong>{t('tabs.address')}</strong></p>
                                            <div style={{
                                                marginTop: '12px',
                                                padding: '10px 14px',
                                                backgroundColor: '#f3f4f6',
                                                borderRadius: '7px',
                                                fontSize: '0.8rem',
                                                color: '#6b7280',
                                                maxWidth: '360px'
                                            }}>
                                                {t('deliveryMap.locationTip', 'Após definir o endereço, arraste o marcador no mapa para a posição exata do seu estabelecimento.')}
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Radius Form */}
                                <div className="modern-form-section">
                                    {/* Seletor do incremento do raio (250 m | 500 m | 1 km) */}
                                    <div className="modern-form-group" style={{ marginBottom: '14px' }}>
                                        <label>
                                            {t('deliveryMap.radiusMode.stepLabel', 'Incremento do raio')}
                                        </label>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                            {[250, 500, 1000].map((m) => (
                                                <button
                                                    key={m}
                                                    type="button"
                                                    onClick={() => handleChangeStep(m)}
                                                    disabled={savingStep}
                                                    style={{
                                                        height: '34px',
                                                        padding: '0 14px',
                                                        borderRadius: '7px',
                                                        fontSize: '0.82rem',
                                                        fontWeight: 600,
                                                        cursor: savingStep ? 'wait' : 'pointer',
                                                        transition: 'all 0.15s',
                                                        border: stepMetros === m ? '1px solid rgb(49,140,213)' : '1px solid #d1d5db',
                                                        background: stepMetros === m ? '#edf4fb' : '#fff',
                                                        color: stepMetros === m ? 'rgb(49,140,213)' : '#6b7280',
                                                    }}
                                                >
                                                    {m < 1000 ? `${m} m` : '1 km'}
                                                </button>
                                            ))}
                                            <span style={{ color: '#9ca3af', fontSize: '0.78rem', marginLeft: '6px' }}>
                                                {t('deliveryMap.radiusMode.stepHint', 'Define de quanto em quanto as faixas aumentam')}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="modern-form-row">
                                        <div className="modern-form-group">
                                            <label>
                                                {t('deliveryMap.radiusMode.rangeLabel', 'Faixa de distância')} <span>*</span>
                                            </label>
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                            }}>
                                                <span style={{
                                                    background: '#edf4fb',
                                                    color: 'rgb(49,140,213)',
                                                    fontWeight: 600,
                                                    padding: '0 12px',
                                                    borderRadius: '7px',
                                                    fontSize: '0.85rem',
                                                    whiteSpace: 'nowrap',
                                                    border: '1px solid #c8ddf0',
                                                    height: '40px',
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }}>
                                                    {formatRadius(nextRangeStart * 1000)}
                                                </span>
                                                <span style={{ color: '#9ca3af', fontWeight: 500, fontSize: '0.85rem' }}>
                                                    {t('deliveryMap.radiusMode.rangeTo', 'a')}
                                                </span>
                                                <div className="modern-number-input">
                                                    <button
                                                        type="button"
                                                        className="modern-number-btn"
                                                        onClick={() => handleDecrement("raio")}
                                                        disabled={round3(raio - stepKm) <= nextRangeStart}
                                                    >
                                                        <MdRemove size={14} />
                                                    </button>
                                                    <input
                                                        type="number"
                                                        value={raio}
                                                        onChange={(e) => {
                                                            // parseFloat: aceita frações de km (0.25 com step 250m).
                                                            // O snap ao múltiplo do incremento acontece no salvar.
                                                            const value = parseFloat(e.target.value);
                                                            if (value > nextRangeStart && value <= 9999) {
                                                                setRaio(value);
                                                            } else if (e.target.value === '') {
                                                                setRaio(round3(nextRangeStart + stepKm));
                                                            }
                                                        }}
                                                        min={round3(nextRangeStart + stepKm)}
                                                        max={9999}
                                                        step={stepKm}
                                                    />
                                                    <button
                                                        type="button"
                                                        className="modern-number-btn"
                                                        onClick={() => handleIncrement("raio")}
                                                        disabled={raio >= 9999}
                                                    >
                                                        <MdAdd size={14} />
                                                    </button>
                                                </div>
                                                <span style={{ color: '#9ca3af', fontWeight: 500, fontSize: '0.85rem' }}>km</span>
                                            </div>
                                        </div>

                                        <div className="modern-form-group">
                                            <label>
                                                {t('deliveryMap.radiusMode.deliveryFeeLabel')} <span>*</span>
                                            </label>
                                            <div
                                                className="modern-input-money-container"
                                                style={{
                                                    border: `1px solid ${isFocused ? 'rgb(49,140,213)' : '#d1d5db'}`,
                                                    borderRadius: '7px',
                                                    transition: 'all 0.2s',
                                                    background: '#fff',
                                                    boxShadow: isFocused ? '0 0 0 3px rgba(49,140,213,0.12)' : '0 1px 2px rgba(0,0,0,0.04)',
                                                    overflow: 'hidden',
                                                    height: '40px',
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }}
                                            >
                                                <InputMoney
                                                    onChange={(event) => onChange(event, 'price', true)}
                                                    value={valorEntrega}
                                                    onFocus={handleFocus}
                                                    onBlur={handleBlur}
                                                    placeholder="0,00"
                                                    addonBefore=""
                                                />
                                            </div>
                                        </div>

                                        <button
                                            type="button"
                                            className="modern-add-btn"
                                            onClick={adicionaRaioNoMapa}
                                            disabled={savingRaio || !raio || valorEntrega === '' || valorEntrega === null || valorEntrega === undefined}
                                        >
                                            <MdAdd size={18} />
                                            {savingRaio ? t('common:saving', 'Salvando...') : t('deliveryMap.radiusMode.addButton')}
                                        </button>
                                    </div>
                                </div>

                                {/* Radius List */}
                                <div className="modern-records-section">
                                    <div className="modern-records-header">
                                        <h3 className="modern-records-title">{t('deliveryMap.radiusMode.registeredTitle', 'Faixas Cadastradas')}</h3>
                                        <span className="modern-records-count">
                                            {arrayRaioEntrega.length} {t('deliveryMap.records', 'registros')}
                                        </span>
                                    </div>

                                    <div className="delivery-data-table">
                                        <div className="delivery-data-thead">
                                            <div className="delivery-data-tr">
                                                <div className="delivery-data-th">{t('deliveryMap.radiusMode.tableHeaders.radius')}</div>
                                                <div className="delivery-data-th col-taxa">{t('deliveryMap.radiusMode.tableHeaders.fee')}</div>
                                                <div className="delivery-data-th col-acoes">{t('deliveryMap.radiusMode.tableHeaders.actions')}</div>
                                            </div>
                                        </div>

                                        <div className="delivery-data-tbody">
                                            {orderedArrayRaioEntrega.length > 0 ? (
                                                orderedArrayRaioEntrega.map((item, index) => (
                                                    <div key={index} className="delivery-data-row">
                                                        <div className="delivery-data-td">
                                                            {formatRadius(index === 0 ? 0 : orderedArrayRaioEntrega[index - 1].raio_entrega)} {t('deliveryMap.radiusMode.rangeTo', 'a')} {formatRadius(item.raio_entrega)}
                                                        </div>
                                                        <div className="delivery-data-td col-taxa">
                                                            {formatPriceWithSymbol(item.valor_entrega)}
                                                        </div>
                                                        <div className="delivery-data-td col-acoes">
                                                            <button
                                                                className="modern-delete-btn"
                                                                onClick={() => deletaRaioEntrega(item._id)}
                                                                title={t('deliveryMap.deleteButton')}
                                                            >
                                                                <BsTrash size={14} />
                                                            </button>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="modern-empty-state">
                                                    <div className="icon">
                                                        <BsMap />
                                                    </div>
                                                    <h3>{t('deliveryMap.radiusMode.emptyState')}</h3>
                                                    <p>{t('deliveryMap.radiusMode.emptyStateDescription', 'Adicione faixas de distância para definir as taxas de entrega')}</p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>

            <ConfirmDialog
                title={t('deliveryMap.confirmDialog.title')}
                open={confirmOpen}
                setOpen={setConfirmOpen}
                onConfirm={changeRegionType}
                confirmText={t('deliveryMap.confirmDialog.confirmButton')}
                cancelText={t('deliveryMap.confirmDialog.cancelButton')}
                onCancel={() => {
                    setConfirmOpen(false);
                    setRegionTypeChange(null);
                    process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Modal de confirmação cancelado');
                }}
            >
                <div style={{ padding: '16px 0' }}>
                    <p style={{ marginBottom: '12px', color: '#374151', fontSize: '0.9rem', lineHeight: '1.5' }}>
                        {t('deliveryMap.confirmDialog.message')}
                    </p>
                    <div style={{
                        background: '#fffbeb',
                        border: '1px solid #fde68a',
                        borderRadius: '7px',
                        padding: '10px 12px',
                        fontSize: '0.8rem',
                        color: '#92400e',
                        lineHeight: '1.4'
                    }}>
                        <strong>{t('deliveryMap.confirmDialog.warningLabel')}:</strong> {t('deliveryMap.confirmDialog.warningText')}
                    </div>
                </div>
            </ConfirmDialog>
        </>
    );

    // Se estiver embedded, retorna apenas o conteudo sem PermissionGate
    if (embedded) {
        return mainContent;
    }

    // Modo normal com PermissionGate
    return (
        <PermissionGate permissions={['default']}>
            {mainContent}
        </PermissionGate>
    );
};

export default AddRaioEntrega;
